import { compact } from 'lodash'

import { AddressFieldConfiguration, AddressModel } from '../types/address'
import { AddressField } from '../constants'

export const getFormattedAddress = (address: AddressModel | null | undefined) => {
  if (!address) return ''

  return compact([
    address?.line1,
    address?.line2,
    address?.city,
    address?.state,
    address?.postalCode,
  ]).join(' ')
}

export const addressFieldConfig: Array<AddressFieldConfiguration> = [
  {
    field: AddressField.Country,
  },
  {
    field: AddressField.Name,
    required: true,
  },
  {
    field: AddressField.Line1,
    required: true,
  },
  {
    field: AddressField.Line2,
  },
  {
    field: AddressField.PostalCode,
    required: true,
  },
  {
    field: AddressField.City,
    required: true,
  },
]
